/**
 * Marge commerciale (§9.11).
 *
 * ⚠️ Deux taux coexistent en commerce, et les confondre fausse toutes les
 * décisions de prix :
 *
 *   • TAUX DE MARGE  = (vente − achat) / ACHAT   → « combien je gagne sur ce
 *     que j'ai dépensé ». C'est celui qu'un commerçant appelle « ma marge ».
 *   • TAUX DE MARQUE = (vente − achat) / VENTE   → part de la marge dans le
 *     prix affiché. C'est celui qu'emploient la grande distribution et les
 *     tableaux de bord de rentabilité.
 *
 * Un achat à 100 revendu 150 donne 50 % de marge et 33 % de marque. Afficher
 * 33 % sous le mot « marge » — ce que faisait l'application — sous-estime la
 * rentabilité d'un tiers et pousse à surévaluer ses prix.
 */
/**
 * @param purchase prix d'achat HT, en entier (ADR-10)
 * @param sale     prix de vente HT, en entier (ADR-10)
 */
export function marginRates(purchase, sale) {
    const amount = sale - purchase;
    return {
        amount,
        // Un prix d'achat nul ne signifie pas une marge infinie mais une donnée
        // absente : on ne calcule pas plutôt que d'afficher un nombre absurde.
        markup: purchase > 0 ? Math.round((amount / purchase) * 100) : null,
        margin: sale > 0 ? Math.round((amount / sale) * 100) : null,
    };
}
//# sourceMappingURL=margin.js.map